import React, {useState} from 'react';
import logoTMB from '../../assets/logo_tmb.png';
import homeIcon from '../../assets/icons/home.png';
import './index.css';
import {
    useNavigate,
} from "react-router-dom";

export default function Header(props) {
    let {isHome} = props;
    const history = useNavigate()
    const goHome = () => {
        history('/')
    }

    return (
        <div>
            <div className="right-tmb-head-wrap">
                <div className="right-tmb-head-container">
                    {!isHome && (
                        <div onClick={() => goHome()} className="right-tmb-head-back-home-container">
                            <img src={homeIcon} alt="icon-home"/>
                        </div>
                    )}
                    <div className={'name-container'}>
                        {props.company === 'tmb' && <img className="logo" src={logoTMB} alt="logo"/>}
                    </div>
                </div>
            </div>
        </div>
    )
}
